import { Text } from '@betterment/samba-react';

import { CHECKING_SUPPORT_PHONE } from '../../Shared/constants';

const CheckingCardActivationErrorMessage: React.FC<React.PropsWithChildren<unknown>> = () => (
  <Text color="text">
    We couldn't activate your card using the information you provided. Please{' '}
    <a href={`tel:${CHECKING_SUPPORT_PHONE}`}> contact us</a> during{' '}
    <a href="https://www.betterment.com/contact/" target="_blank" rel="noopener noreferrer">
      business hours
    </a>{' '}
    to resolve this issue.
  </Text>
);

export default CheckingCardActivationErrorMessage;
